import { z } from 'zod';
import { PAYMENT_METHODS } from '../payments';
import { DISCOUNT_TYPES } from '../money';
import { moneySchema, optionalText } from './common';

export const paymentCreateSchema = z.object({
  amount: moneySchema.refine((v) => v > 0, 'Informe um valor maior que zero'),
  method: z.enum(PAYMENT_METHODS, { errorMap: () => ({ message: 'Forma de pagamento inválida' }) }),
  paidAt: z
    .string()
    .refine((v) => !Number.isNaN(Date.parse(v)), 'Data inválida')
    .optional(),
  notes: optionalText(500, 'Observação'),
  /** Taxa da maquininha (só cartão): em % do valor ou em R$. Abatida do lucro; o cliente paga o valor cheio. */
  feeType: z.enum(DISCOUNT_TYPES).nullish(),
  feeValue: z.number().min(0, 'Taxa inválida').max(100000).nullish(),
});
export type PaymentCreateInput = z.infer<typeof paymentCreateSchema>;

export const paymentRefundSchema = z.object({
  reason: z.string().trim().min(3, 'Informe o motivo do estorno').max(500),
});

export const orderDiscountSchema = z
  .object({
    type: z.enum(DISCOUNT_TYPES).nullable(),
    value: z.number().min(0, 'Desconto inválido').max(10_000_000),
  })
  .refine((d) => d.type !== 'PERCENT' || d.value <= 100, { path: ['value'], message: 'O desconto máximo é 100%' });
export type OrderDiscountInput = z.infer<typeof orderDiscountSchema>;
